import React from "react"

const EmploymentDetailsIcon = ({color:stroke={stroke}}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6665 5.8335H3.33317C2.4127 5.8335 1.6665 6.57969 1.6665 7.50016V15.8335C1.6665 16.754 2.4127 17.5002 3.33317 17.5002H16.6665C17.587 17.5002 18.3332 16.754 18.3332 15.8335V7.50016C18.3332 6.57969 17.587 5.8335 16.6665 5.8335Z"
        stroke={stroke}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3332 17.5V4.16667C13.3332 3.72464 13.1576 3.30072 12.845 2.98816C12.5325 2.67559 12.1085 2.5 11.6665 2.5H8.33317C7.89114 2.5 7.46722 2.67559 7.15466 2.98816C6.8421 3.30072 6.6665 3.72464 6.6665 4.16667V17.5"
        stroke={stroke}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default EmploymentDetailsIcon
